export const CONTAINER_SIZE_IN_PX = '1025px';

export const MONS_OVERRIDE_COOKIE = 'mons-override';

export const SITE_QUERY_PARAM = 'site';

export const MONS_DIRECTOR_ID_QUERY_PARAM = 'mons_sel_dir_paid';
